import { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { developAxios } from "../../axios.config";
import { CardMedia, Box, Paper, Button, Grid, Modal } from "@mui/material";
import Select from "react-select";
import { AllCourseContext } from "../../Context/AllCourse";
import { updateLearningData } from "./utils";
import { useSnackbar } from "notistack";
import { Store } from "react-notifications-component";

const ContainerMain = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 100%;
	gap: 4px;

	.courses-select {
		width: 50%;
		height: 100%;
	}
`;

const UploadVideo = () => {
	const { enqueueSnackbar } = useSnackbar();
	const [state, setState] = useState([]);
	const [courses, setCourses] = useState([]);
	const [selectedLearningForClone, setSelectedLearningForClone] = useState(
		{}
	);
	const [selectedCourseForClone, setSelectedCourseForClone] = useState("");
	const history = useHistory();
	const { course, setCourseId, courseId } = useContext(AllCourseContext);
	const [editVideoCart, setEditVideoCart] = useState(null);
	const [contentArray, setContentArray] = useState([]);

	const handleContentInputChange = (e, index) => {
		const { name, value, type, checked } = e.target;
		const updatedContent = [...contentArray];
		if (type === "checkbox") {
			updatedContent[index][name] = checked;
		} else {
			updatedContent[index][name] = value;
		}
		setEditVideoCart({
			...editVideoCart,
			content: updatedContent,
		});
	};
	const handleDeleteContentArray = (index) => {
		const updatedContent = [...contentArray];
		updatedContent.splice(index, 1);
		setContentArray(updatedContent);
	};
	const handleHeadingInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		const newValue = type === "checkbox" ? checked : false;
		setEditVideoCart({
			...editVideoCart,
			[name]: value,
			locked: newValue,
		});
	};
	const handleEditVideoCard = (techId, courseid) => {
		//courseid is like id of mern stack
		// techId is link item of mern stack like linux.
		// console.log(state);
		const [a] = state.filter((val) => val._id === techId);
		setContentArray(a.content);

		setEditVideoCart({
			...a,
			courseId: courseid,
			headingId: techId,
		});
	};
	const SubmitEditVideoCard = () => {
		let mn = {
			...editVideoCart,
		};
		delete mn._id;
		delete mn.content;
		mn = {
			...mn,
			content: contentArray,
		};
		console.log(mn);
		developAxios(localStorage.getItem("token"))
			.post("/update-specific-learning-data", mn)
			.then((data) => {
				setEditVideoCart(null);
				setContentArray([]);
				// console.log(data.data.updateData.learning);
				// console.log(state);
				setState(data.data.updateData.learning);

				Store.addNotification({
					title: "Updated !!!",
					message: "Successfuly Updated !!!",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
			})
			.catch((err) => {
				alert("err");
				console.log(err);

				Store.addNotification({
					title: "Something went wrong ......",
					message: "error occured !!!",
					type: "danger",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
			});
	};
	useEffect(() => {
		let temp_course = course.map((ele) => {
			return {
				label: ele.name,
				value: ele._id,
			};
		});

		setCourses(temp_course);
	}, [course]);

	useEffect(() => {
		if (!courseId || courseId === "") return;
		developAxios(localStorage.getItem("token"))
			.get(`/get-learning-data/${courseId.value}`)
			.then(({ data }) => {
				setState(data.data.learning);
			})
			.catch((err) => console.log(err));
	}, [courseId]);

	const handleClose = () => {
		setSelectedLearningForClone({});
	};

	return (
		<>
			<ContainerMain>
				<Select
					options={courses}
					placeholder="Select Course"
					onChange={(e) => {
						setCourseId(e);
					}}
					className="courses-select"
				/>
				{state ? (
					<Grid container spacing={3} sx={{ mt: "20px" }}>
						{state.length > 0 &&
							state.map((item) => {
								return (
									<Grid
										item
										xs={1}
										sm={2}
										md={3}
										lg={4}
										key={item._id}
										sx={{
											display: "flex",
											justifyContent: "center",
										}}
									>
										<Paper
											elevation={6}
											sx={{
												width: 300,
												my: 2,
												display: "flex",
												flexDirection: "column",
												justifyContent: "space-between",
												alignItems: "center",
												p: 2,
											}}
										>
											<Box
												sx={{
													width: 100,
													height: 100,
													my: 3,
												}}
											>
												<CardMedia
													component="img"
													alt="card-logo"
													image={item.headingLogo}
													sx={{
														width: 100,
														objectFit: "contain",
														height: 100,
													}}
												/>
											</Box>
											<Box
												sx={{
													display: "flex",
													gap: 2,
												}}
											>
												<Button
													variant="contained"
													onClick={() => {
														history.push(
															`/video-upload/${item._id}?course=${courseId.value}`
														);
													}}
												>
													View
												</Button>
												<Button
													variant="contained"
													onClick={() => {
														setSelectedLearningForClone(
															item
														);
													}}
												>
													Clone
												</Button>
												<Button
													onClick={() => {
														handleEditVideoCard(
															item._id,
															courseId.value
														);
													}}
													variant="contained"
												>
													Edit
												</Button>
											</Box>
										</Paper>
									</Grid>
								);
							})}
					</Grid>
				) : (
					<div className="h-screen w-screen flex items-center justify-center">
						{" "}
						Loading ....
					</div>
				)}
				<Box sx={{ display: "flex", justifyContent: "center" }}>
					<Button
						variant="contained"
						onClick={() => {
							history.push(
								"/video-upload/add-learning-card?course=" +
									courseId.value
							);
						}}
						color="success"
						sx={{
							px: 4,
						}}
					>
						Add
					</Button>
				</Box>

				<Modal
					open={Object.keys(selectedLearningForClone).length !== 0}
					onClose={handleClose}
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Box
						sx={{
							width: 400,
							bgcolor: "background.paper",
							border: "2px solid #000",
							p: 2,
							m: 1,
						}}
					>
						<h2>Select the course to clone</h2>
						<Select
							options={courses}
							placeholder="Select Course"
							onChange={(e) => {
								setSelectedCourseForClone(e.value);
							}}
							className="courses-select"
						/>
						<Button
							variant="contained"
							onClick={() => {
								const learningData = {
									heading: selectedLearningForClone.heading,
									headingLogo:
										selectedLearningForClone.headingLogo,
									content: selectedLearningForClone.content,
									locked: selectedLearningForClone.locked,
								};
								updateLearningData(
									selectedCourseForClone,
									learningData
								);
								handleClose();
								enqueueSnackbar("Cloned successfully", {
									variant: "success",
								});
							}}
							color="success"
							sx={{
								px: 4,
								mt: 2,
							}}
						>
							Clone
						</Button>
					</Box>
				</Modal>
			</ContainerMain>
			{editVideoCart ? (
				<dialog
					open={true}
					className="fixed inset-0 flex flex-col h-screen  justify-center items-center w-full  bg-black bg-opacity-50"
				>
					<div className="flex flex-row items-center justify-end">
						<Button
							type="button"
							onClick={() => {
								SubmitEditVideoCard();
							}}
							style={{
								// position: "fixed",
								// top: "0rem",
								backgroundColor: "green",
								padding: "10px",
							}}
							className="font-bold text-white"
						>
							Update
						</Button>

						<button
							onClick={() => {
								setEditVideoCart(null);
								setContentArray([]);
							}}
							// className="absolute right-0 top-0 "
							type="button"
						>
							<svg
								width="58px"
								height="58px"
								viewBox="0 0 24.00 24.00"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									{" "}
									<path
										opacity="0.5"
										d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
										fill="#1C274C"
									></path>{" "}
									<path
										d="M8.96967 8.96967C9.26256 8.67678 9.73744 8.67678 10.0303 8.96967L12 10.9394L13.9697 8.96969C14.2626 8.6768 14.7374 8.6768 15.0303 8.96969C15.3232 9.26258 15.3232 9.73746 15.0303 10.0304L13.0607 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0304 15.0303C9.73746 15.3232 9.26258 15.3232 8.96969 15.0303C8.6768 14.7374 8.6768 14.2626 8.96969 13.9697L10.9394 12L8.96967 10.0303C8.67678 9.73744 8.67678 9.26256 8.96967 8.96967Z"
										fill="#1C274C"
									></path>{" "}
								</g>
							</svg>
						</button>
					</div>

					<div className="bg-white w-[100%] xl:w-[80%]  overflow-y-scroll border border-red-700 h-[90%] p-6 rounded-lg shadow-lg">
						<div>
							<span className="block mb-2">
								Heading:{" "}
								<input
									name="heading"
									value={editVideoCart.heading}
									type="text"
									className="border rounded-md px-2 py-1 w-full focus:outline-none focus:border-blue-500"
									onChange={handleHeadingInputChange}
								/>
							</span>
							<span className="block mb-2">
								Heading Logo:{" "}
								<input
									name="headingLogo"
									value={editVideoCart.headingLogo}
									type="text"
									className="border rounded-md px-2 py-1 w-full focus:outline-none focus:border-blue-500"
									onChange={handleHeadingInputChange}
								/>
							</span>
							<span className="block mb-2">
								Locked:{" "}
								<input
									name="locked"
									checked={editVideoCart.locked}
									type="checkbox"
									className="w-5 h-5"
									onChange={handleHeadingInputChange}
								/>
							</span>
							<table style={{ border: "1px solid black" }}>
								<thead>
									<tr>
										<th
											scope="col"
											className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-black uppercase tracking-wider"
										>
											Name
										</th>
										<th
											scope="col"
											className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-black uppercase tracking-wider"
										>
											Description
										</th>
										<th
											scope="col"
											className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-black uppercase tracking-wider"
										>
											Foundation
										</th>
										<th
											scope="col"
											className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-black uppercase tracking-wider"
										>
											Prodoc
										</th>
										<th
											scope="col"
											className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-black uppercase tracking-wider"
										>
											Locked
										</th>
									</tr>
								</thead>
								<tbody
									style={{
										border: "1px solid black",
									}}
								>
									{contentArray.map((each, index) => {
										return (
											<tr key={index}>
												<td className="px-3 py-2 flex flex-row">
													<button
														onClick={() => {
															handleDeleteContentArray(
																index
															);
														}}
														type="button"
														className="mr-2"
													>
														<svg
															width="1.2rem"
															height="1.2rem"
															viewBox="0 -0.5 21 21"
															version="1.1"
															xmlns="http://www.w3.org/2000/svg"
															fill="#000000"
														>
															<g
																id="SVGRepo_bgCarrier"
																stroke-width="0"
															></g>
															<g
																id="SVGRepo_tracerCarrier"
																stroke-linecap="round"
																stroke-linejoin="round"
															></g>
															<g id="SVGRepo_iconCarrier">
																{" "}
																<title>
																	delete
																	[#1487]
																</title>{" "}
																<desc>
																	Created with
																	Sketch.
																</desc>{" "}
																<defs> </defs>{" "}
																<g
																	id="Page-1"
																	stroke="none"
																	stroke-width="1"
																	fill="none"
																	fill-rule="evenodd"
																>
																	{" "}
																	<g
																		id="Dribbble-Light-Preview"
																		transform="translate(-179.000000, -360.000000)"
																		fill="#000000"
																	>
																		{" "}
																		<g
																			id="icons"
																			transform="translate(56.000000, 160.000000)"
																		>
																			{" "}
																			<path
																				d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z"
																				id="delete-[#1487]"
																			>
																				{" "}
																			</path>{" "}
																		</g>{" "}
																	</g>{" "}
																</g>{" "}
															</g>
														</svg>
													</button>
													<input
														type="text"
														name="name"
														value={each.name}
														className="border rounded-md px-2 py-1 w-full focus:outline-none focus:border-blue-500"
														onChange={(e) =>
															handleContentInputChange(
																e,
																index
															)
														}
													/>
												</td>
												<td className="px-3 py-2">
													<input
														type="text"
														name="description"
														value={each.description}
														className="border rounded-md px-2 py-1 w-full focus:outline-none focus:border-blue-500"
														onChange={(e) =>
															handleContentInputChange(
																e,
																index
															)
														}
													/>
												</td>
												<td className="px-3 py-2">
													<input
														type="text"
														name="foundation"
														value={each.foundation}
														className="border rounded-md px-2 py-1 w-full focus:outline-none focus:border-blue-500"
														onChange={(e) =>
															handleContentInputChange(
																e,
																index
															)
														}
													/>
												</td>
												<td className="px-3 py-2">
													<input
														type="text"
														name="prodoc"
														value={each.prodoc}
														className="border rounded-md px-2 py-1 w-full focus:outline-none focus:border-blue-500"
														onChange={(e) =>
															handleContentInputChange(
																e,
																index
															)
														}
													/>
												</td>
												<td className="px-3 py-2">
													<input
														type="checkbox"
														name="locked"
														checked={each.locked}
														className="border rounded-md px-2 py-1 w-full focus:outline-none focus:border-blue-500"
														onChange={(e) =>
															handleContentInputChange(
																e,
																index
															)
														}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
							{/* <button */}
							{/*     className="p-2 bg-blue-300 mt-1" */}
							{/*     type="button" */}
							{/*     onClick={() => { */}
							{/*         const a = { */}
							{/*             foundation: "", */}
							{/*             prodoc: "", */}
							{/*             name: "", */}
							{/*             description: "", */}
							{/*             locked: false, */}
							{/*             _id: "", */}
							{/*             // id is required so we cant add them namualluy */}
							{/*         }; */}
							{/*         setContentArray((prev) => [...prev, a]); */}
							{/*     }} */}
							{/* > */}
							{/*     + Add To Content */}
							{/* </button> */}
						</div>
					</div>
				</dialog>
			) : (
				<></>
			)}
		</>
	);
};

export default UploadVideo;
